import React from 'react'
import { connect } from 'react-redux'
import { Accordion, Card } from 'react-bootstrap'

import WithAuth from '../../HOCs/WithAuth'

import { userIsPortalAdmin, userCanSeeAllRoutes, userIsInvestigator } from '../../functions/userPermissions'

import ChangePassword from './components/ChangePassword'
import AddUser from './components/AddUser'

import './style.css'


const UserSettingsContainer = (props) => {

  const { currentUser } = props

  const defaultActiveKey = userCanSeeAllRoutes(currentUser) || userIsPortalAdmin(currentUser) || userIsInvestigator(currentUser) ? null : '0'

  return (
    <div className="ChartsContainer" id='UserSettingsContainer'>
      <Accordion defaultActiveKey={defaultActiveKey}>

        <Card>
          <Accordion.Toggle as={Card.Header} eventKey='0'>
            Change Password
          </Accordion.Toggle>
          <Accordion.Collapse eventKey='0'>
            <Card.Body>
              <ChangePassword alert={props.alert} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        {userIsPortalAdmin(currentUser) || userCanSeeAllRoutes(currentUser) || userIsInvestigator(currentUser) ?
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey='1'>
            Add User
            </Accordion.Toggle>

            <Accordion.Collapse eventKey='1'>
              <Card.Body>
                <AddUser 
                  alert={props.alert} 
                  currentUser={currentUser} 
                />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          :
          null
        }

      </Accordion>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.loginReducer.currentUser,
  }
}

export default WithAuth(connect(mapStateToProps)(UserSettingsContainer))
